import {
  AlertClasses,
  generateUtilityClasses,
  alertClasses as muiAlertClasses,
} from '@mui/material';

// Module augmentation for Button classes
declare module '@mui/material/Alert' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface AlertClasses extends WsdAlertClasses {}
}

export interface WsdAlertClasses {
  sizeMedium: string;
  sizeSmall: string;
  sizeXsmall: string;
}

export const wsdAlertClasses: WsdAlertClasses = generateUtilityClasses(
  'MuiAlert',
  ['sizeMedium', 'sizeSmall', 'sizeXsmall']
);

const alertClasses: AlertClasses = {
  ...muiAlertClasses,
  ...wsdAlertClasses,
};

export default alertClasses;
